var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Group",
    {
      attrs: {
        state: _vm.valid,
        "invalid-feedback": _vm.error,
        "feedback-beneath": ""
      }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("b-select", {
            staticClass: "w-auto d-inline-block",
            attrs: { options: _vm.options },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.min,
              callback: function($$v) {
                _vm.min = $$v
              },
              expression: "min"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mx-2" }, [_vm._v("bis")]),
          _vm._v(" "),
          _c("b-select", {
            staticClass: "w-auto d-inline-block",
            attrs: { options: _vm.options },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.max,
              callback: function($$v) {
                _vm.max = $$v
              },
              expression: "max"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "ml-2" }, [_vm._v(_vm._s(_vm.suffix))])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }